import React, { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { FaIcon } from '@atoms/icons';

export type MenuButtonProps = {
  items: ActionMenuItem[];
  id: string;
};
export function MenuButton({ items, id }: MenuButtonProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        sx={{ height: '24px', width: '24px', fontSize: '13px' }}
        onClick={handleClick}
        id="action-button"
        aria-controls={open ? 'action-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <FaIcon name="ellipsis-vertical" />
      </IconButton>

      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        MenuListProps={{
          'aria-labelledby': 'action-button',
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.key}
            onClick={() => {
              item.onClick?.(id);
              onClose();
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

type ActionMenuItem = {
  label: ReactNode;
  onClick?: (rowId: string) => void;
  key: string;
};
